import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import LoanApplicationFactory from '../../../domain/newLoanApplication/LoanApplicationFactory';
import Collection from '../../../domain/valueObject/Collection';
import { NewLoanApplicationStepsProps } from '../../../pages/NewLoanApplication';
import { NewLoanSteps } from '../../../utils/enums';
import PartInputField from '../../parts/PartInputField';
import BlockStepsButtons from '../BlockStepsButtons';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

interface OrigPurchasePriceProps extends NewLoanApplicationStepsProps {}

const OrigPurchasePrice = ({
    nextStep,
    prevStep,
    newLoanEntity
}: OrigPurchasePriceProps) => {
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm({
        mode: 'onChange',
        shouldFocusError: false,
        resolver: yupResolver(
            yup.object().shape({
                originalPurchasePrice: yup
                    .string()
                    .required('Please complete this required field.')
                    .matches(
                        /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
                        'You must specify a number.'
                    )
            })
        )
    });

    const onSubmit = (data: any) => {
        LoanApplicationFactory.makeFromForm(
            newLoanEntity,
            new Collection(data)
        );

        nextStep(NewLoanSteps.REHAB_AMOUNT_SPEND);
    };

    const handlePrevStep = () => {
        LoanApplicationFactory.makeFromForm(
            newLoanEntity,
            new Collection(getValues())
        );
        prevStep(NewLoanSteps.DATE_OF_PURCHASE);
    };

    useEffect(() => {
        newLoanEntity.hasOriginalPurchasePrice() &&
            setValue(
                'originalPurchasePrice',
                newLoanEntity.originalPurchasePrice.value
            );
    }, []);

    return (
        <div className="login">
            <div className="container">
                <h1 className="login__title">
                    What was your purchase price when you originally acquired
                    this property?
                </h1>
                <p className="login__subtitle login__subtitle--middle">
                    Price of Original Purchase
                </p>
                <div className="login__box">
                    <PartInputField
                        label="Original Purchase Price"
                        name="originalPurchasePrice"
                        control={control}
                        errors={errors}
                        isRequired
                        isDollarAmount={true}
                    />
                    <BlockStepsButtons
                        prevStep={handlePrevStep}
                        nextStep={handleSubmit(onSubmit)}
                    />
                </div>
            </div>
        </div>
    );
};

export default OrigPurchasePrice;
